import React from 'react';
import { Modal, ModalBody } from 'reactstrap'
import Loading from './Loading'

const LoadingModal = (props) => {
  const {isProcessing} = props

  return (
    <Modal isOpen={isProcessing} className={`loading-panel`} centered={true}>
      <ModalBody>
        <Loading className="fa-7x" />
      </ModalBody>
    </Modal>
  )
}

export default LoadingModal;
